module.exports = __webpack_public_path__ + "static/media/guest_book_image.cee9ba8f.png";